import '../plugins/teletype';

const type_it = {

	ui: {},

	init: function() {
		this.bindUI();
		//this.bindEvents();

		this.bindTypeIt();
	},

	bindUI: function() {
		this.ui.$type_it = $(".js-type-it");
	},

	bindEvents: function() {

	},

	bindTypeIt: function() {
		this.ui.$type_it.each(function() {
			let word_list = $.parseJSON($(this).attr('data-type-it-list'));

			$(this).teletype({
				text: word_list,
				type_speed: 75,
				before_type_pause: 250,
				after_type_pause: 3000
			});
		});

	},
};

module.exports = type_it;
